import { createApp } from 'vue';
import PrimeVue from 'primevue/config';
import Nora from '@primeuix/themes/nora';
import { definePreset } from '@primeuix/themes';
import App from './App.vue';

import router from './router';
import { PublicClientApplication } from "@azure/msal-browser";
import { AuthService } from '@/service/AuthService.js';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';

import '@/assets/styles.scss';

const app = createApp(App);

const MyPreset = definePreset(Nora, {
    semantic: {
        primary: {
            50: '#f0f3f9',
            100: '#d9deec',
            200: '#b3bdd9',
            300: '#8b9dc7',
            400: '#647cb4',
            500: '#3e5ba1',
            600: '#1d3f8e',
            700: '#1b3678',
            800: '#192d63',
            900: '#1D2E5A',
            950: '#0c1529'
        }
    }
});

// Define layout
app.use(PrimeVue, {
    theme: {
        preset: MyPreset,
        options: {
            prefix: 'p-',
            darkModeSelector: '.app-dark',
            primaryColor: 'apar'
        }
    }
});

app.use(ToastService);
app.use(ConfirmationService);


(async () => {
    
    // Create a global MSAL instance
    var msalConfig = await AuthService.getConfiguration();  // Fetch the configuration from AuthService
    if (!msalConfig) {
        console.error('MSAL configuration not found');
        throw new Error('MSAL configuration not found');
    }
    
    const msalInstance = new PublicClientApplication(msalConfig);

    await msalInstance.initialize(); // Ensure MSAL is ready
    app.provide("msalInstance", msalInstance);
    app.use(router);
    app.mount("#app");
  })();

